import { render, staticRenderFns } from "./ProfesorCursos.vue?vue&type=template&id=6bdc1610"
import script from "./ProfesorCursos.vue?vue&type=script&lang=js"
export * from "./ProfesorCursos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports